export default __webpack_public_path__ + "static/media/HDTX_Pemanggilan RUPS 30 Juni 2025.08152784.pdf";